import React from 'react';
import { USTeamDashboard } from '@/components/dashboard/USTeamDashboard';
import { DashboardAccessGate } from '@/components/dashboard/DashboardAccessGate';
import { DashboardAccessNotificationProvider } from '@/components/dashboard/DashboardAccessNotificationProvider';

const ConsultantDashboard = () => {
  return (
    <DashboardAccessNotificationProvider>
      <DashboardAccessGate dashboardType="consultant">
        <USTeamDashboard />
      </DashboardAccessGate>
    </DashboardAccessNotificationProvider>
  );
};

export default ConsultantDashboard;
